'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _Redux = require('Redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _root = require('MeetingsLib/redux/reducers/root');

var _root2 = _interopRequireDefault(_root);

var _RavenContextMiddleware = require('MeetingsLib/redux/middleware/RavenContextMiddleware');

var _RavenContextMiddleware2 = _interopRequireDefault(_RavenContextMiddleware);

var _TrackingMiddleware = require('MeetingsLib/redux/middleware/TrackingMiddleware');

var _TrackingMiddleware2 = _interopRequireDefault(_TrackingMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStore(initialState, httpClient) {
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _Redux.compose;

  var createStoreWithMiddleware = composeEnhancers((0, _Redux.applyMiddleware)(_reduxThunk2.default.withExtraArgument(httpClient), _TrackingMiddleware2.default, _RavenContextMiddleware2.default))(_Redux.createStore);

  return createStoreWithMiddleware(_root2.default, initialState);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/utils/createStore.js
// module id = 515
// module chunks = 0